module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Fine-Standard-Regular-Italic.0992a6f9.eot";